<div class="main-container">
    <br><br>
    <div class="carousel-container">
        <div id="compressorCarousel" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../assets/img/active-product/animationproduct17.jpg" style="border-radius: 15px; box-shadow: 10px;"  height="50%" width="50%">
                </div>
            </div>
            <a class="carousel-control-prev" href="#compressorCarousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#compressorCarousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>

    <!-- Contact Information Section (Second Section) -->
    <div class="contact-info">
        <a href="tel:8489359948" class="contact-btn phone-btn">
            <span class="fa fa-phone"></span> Call Now
        </a>
        <a href="mailto:rvproduction2017@gmail.com" class="contact-btn email-btn">
            <span class="fa fa-envelope"></span> Email Us
        </a>
        <a href="https://wa.me/8489359948" target="_blank" class="contact-btn whatsapp-btn">
            <span class="fa fa-whatsapp"></span>WhatsApp
        </a>
    </div>

    <!-- Multi Brand Piston Compressor Title and Tagline (Third Section) -->
    <div class="header">
        <h1 class="title">AIR ACCESSORIES COMPRESSORS</h1>
            <img src="../../assets/img/active-product/animationproduct18.jpg" style="border-radius: 15px; box-shadow: 10px;"  height="50%" width="50%">
        <br><p class="tagline">Optimized Air Solutions for Every Industry Need</p>
        <p class="tagline1">
           <li>Air Accessories Compressors are advanced machines designed to deliver high-quality compressed air for a variety of industrial applications.</li>
        </p>
        <p class="tagline1">
           <li>These compressors are engineered for efficiency, offering a reliable solution to meet both constant and fluctuating air demand.</li>
        </p>
        <p class="tagline1">
            <li>Featuring a robust construction, they provide exceptional performance even in harsh environments, while minimizing operational costs.</li>
        </p>
        <p class="tagline1">
            <li>Our air accessories compressors come with features like reduced energy consumption, quieter operations, and low maintenance needs, ensuring long-term operational savings.</li>
        </p>
        <p class="tagline1">
           <li>These compressors are ideal for industries such as manufacturing, construction, automotive, and HVAC, where continuous and reliable air supply is critical.</li>
        </p>
        <p class="tagline1">
           <li>Built with advanced technology, our compressors also ensure lower carbon footprints by optimizing power use and reducing waste.</li>
        </p>
        <p class="tagline1">
           <li>Whether for general-purpose or specialized applications, our air accessories compressors deliver the performance you need to keep your operations running smoothly.</li>
        </p>
    </div>
    

    <!-- Feature Highlights Section (Last Section) -->
    <div class="feature-highlights">
        <div class="feature-card">
            <i class="fa fa-cogs"></i>
            <h4 class="font-weight-bold">Quick Response</h4>
            <p>We respond quickly to minimize downtime.</p>
        </div>
        <div class="feature-card">
            <i class="fa fa-check-circle"></i>
            <h4 class="font-weight-bold">Genuine Parts</h4>
            <p>We only use OEM parts for reliability.</p>
        </div>
    </div>
</div>
